<template>
	<el-menu
		:default-active="mainMenuActiveIndex"
		@select="handleSelect"
		text-color="#111"
		active-text-color="#E6A23C"
		:router="true"
		:unique-opened="true"
	>
		<el-submenu :index="menuGroup.index" v-for="(menuGroup,index) in realMenus" :key="index">
			<template slot="title">
				<i :class="'el-icon-'+menuGroup.icon"></i>
				<span>{{menuGroup.title}}</span>
			</template>
			<el-menu-item
				:route="{ name: menu.router, params:menu.param}"
				:index="menu.index"
				v-for="(menu,indexM) in menuGroup.subItems"
				:key="indexM"
			>{{menu.title}}</el-menu-item>
		</el-submenu>
	</el-menu>
</template>
<script type="text/javascript">
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	name: "Menu-bar",
	data() {
		return {
			menus: [
				{
					icon: "location",
					title: "个人中心",
					index: "User",
					subItems: [
						{
							index: "User-Dashboard",
							title: "仪表盘",
							router: "User-Dashboard",
							param: {},
							privilege: [],
						},
						{
							index: "User-Setting",
							title: "个人设置",
							router: "User-Setting",
							param: {},
							privilege: [],
						},
					],
				},
				{
					icon: "goods",
					title: "活动",
					index: "Active",
					subItems: [
						{
							index: "Active-Index",
							title: "活动管理",
							router: "Active-Index",
							param: {},
							privilege: [40],
						},
					],
				},

				{
					icon: "setting",
					title: "设置",
					index: "Config",
					subItems: [
						{
							index: "Setting-Store",
							title: "门店",
							router: "Setting-Store",
							param: {},
							privilege: [21],
						},
						{
							index: "Config-Config",
							title: "全局配置",
							router: "Config-Config",
							param: {},
							privilege: [21],
						},
						{
							index: "Config-Admin",
							title: "管理员",
							router: "Config-Admin",
							param: {},
							privilege: [20],
						},
					],
				},
				{
					icon: "service",
					title: "会员",
					index: "Customer",
					subItems: [
						{
							index: "Customer-User",
							title: "普通用户",
							router: "Customer-User",
							param: {},
							privilege: [30],
						},
					],
				},
			],
		};
	},

	computed: {
		...mapState(["mainMenuActiveIndex", "hasMenuBar", "userPrivilege"]),
		realMenus: function() {
			let menus = [];
			let privilegeMapping = {};
			this.userPrivilege.forEach(val => {
				privilegeMapping[val] = 1;
			});
			for (let i = 0; i < this.menus.length; i++) {
				let this_submenu = [];
				this_submenu = this.menus[i].subItems.filter(val => {
					if (!val.privilege || val.privilege.length == 0) {
						return true;
					}
					for (let j = 0; j < val.privilege; j++) {
						if (privilegeMapping[val.privilege[j]]) {
							return true;
						}
					}
					return false;
				});

				if (this_submenu.length > 0) {
					let this_menu = JSON.parse(JSON.stringify(this.menus[i]));
					this_menu.subItems = JSON.parse(JSON.stringify(this_submenu));
					menus.push(this_menu);
				}
			}
			return menus;
		},
	},
	created() {},
	mounted() {},

	methods: {
		handleSelect(key, keyPath) {
			console.log(key, keyPath);
		},
	},
	components: {},
};
</script>
